import { Alert, Button } from '@mui/material'

import { useAppContext } from '@/hooks'

interface WarningBannerProps {
	handleOpenModal: () => void
}

export const WarningBanner = ({ handleOpenModal }: WarningBannerProps) => {
	const { t } = useAppContext()
	return (
		<Alert
			severity="warning"
			action={
				<Button
					color="inherit"
					size="small"
					onClick={handleOpenModal}
					data-testid="warning-banner-review-button"
				>
					Review and Remove
				</Button>
			}
			sx={{ mb: 3 }}
		>
			{t('WARNING_BANNER')}
		</Alert>
	)
}
